import { BaseModel } from './base';

// Enums

export enum CustomDomainStatus {
  none = 0,
  waitingDNS = 1,
  failing = 2,
  active = 3,
}

export const CustomDomainStatusLabels: Record<CustomDomainStatus, string> = {
  [CustomDomainStatus.none]: 'general.none',
  [CustomDomainStatus.waitingDNS]: 'minisite.waitingDNS',
  [CustomDomainStatus.failing]: 'api.models.settings.failing',
  [CustomDomainStatus.active]: 'general.active',
};

// Helper Classes

export class EmailSending extends BaseModel {}
export class AutoTopUp extends BaseModel {}
export class SMSCountry extends BaseModel {}
export class Reminders extends BaseModel {}
export class Privacy extends BaseModel {}

export class AuthorisedSession extends BaseModel {
  session!: string;

  override objectID(): string | null {
    return this.session ?? null;
  }
}

// Settings is not a model itself in the new system — it's just a service namespace
export class Settings extends BaseModel {}
